import script from "./formQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./formQuery.vue?vue&type=script&setup=true&lang=js"

import "./formQuery.vue?vue&type=style&index=0&id=506e721c&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-506e721c"]])

export default __exports__